import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Icon from "../Icon";
import { Dots } from "../motion/Reveal";

export function Breadcrumbs({ items, dark = false }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-2 text-xs">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-2">
            {i > 0 && <span className={dark ? "text-white/30" : "text-slate-300"}>/</span>}
            {item.to ? (
              <Link to={item.to} className={`transition-colors duration-150 ${dark ? "text-white/60 hover:text-white" : "text-slate-500 hover:text-navy"}`}>
                {item.label}
              </Link>
            ) : (
              <span className={dark ? "text-white/90" : "text-navy"}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default function PageHero({ eyebrow, title, description, breadcrumbs, children, testid }) {
  return (
    <section className="hero-spotlight relative overflow-hidden pb-16 pt-32 sm:pb-20 sm:pt-40 lg:pb-24" data-testid={testid || "page-hero"}>
      <div className="relative mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
        {breadcrumbs && <Breadcrumbs items={breadcrumbs} dark />}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          {eyebrow && (
            <p className="mb-4 flex items-center gap-3 font-mono-accent text-xs uppercase tracking-[0.25em] text-dot-amber">
              <Dots size="h-1.5 w-1.5" /> {eyebrow}
            </p>
          )}
          <h1 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {description && <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">{description}</p>}
          {children}
        </motion.div>
      </div>
    </section>
  );
}

export function ArrowLink({ to, children, light = false, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`group inline-flex items-center gap-2 text-sm font-semibold transition-colors duration-200 ${
        light ? "text-white hover:text-dot-amber" : "text-navy hover:text-dot-blue"
      }`}
    >
      {children}
      <Icon name="ArrowRight" className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
    </Link>
  );
}
